import React from 'react'

function ArtsHumanities() {
  return (
    <div>ArtsHumanities</div>
  )
}

export default ArtsHumanities